import IWithdrawalLayer from "./IWithdrawalLayer";
import NetworkLogic from "../../Shared/NetworkLogic";
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import ToggleItem from "../../Common/ToggleItem";
import UIManager from "../../Shared/UIManager";

const Type2LinkName = ["", "ERC20", "Omni", "TRC20"]
const {ccclass, property} = cc._decorator;

@ccclass
export default class WalletManagerLayer extends IWithdrawalLayer {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Node)
    nodeInfoLayer: cc.Node = null

    @property(cc.Node)
    nodeBankLayer: cc.Node = null

    @property(cc.Node)
    nodeOtherLayer: cc.Node = null

    @property(cc.Node)
    nodeUsdtLayer: cc.Node = null
    
    @property(cc.Layout)
    lytBankInfoList: cc.Layout = null

    @property(cc.Node)
    bankListNode: cc.Node = null

    @property(cc.Layout)
    lytBankList: cc.Layout = null
    
    @property(cc.Node)
    nodeTemplateCard: cc.Node = null

    @property(cc.Node)
    nodeTemplateAddCard: cc.Node = null

    @property(cc.Node)
    nodeTemplateBank: cc.Node = null

    @property(cc.EditBox)
    ebUserNameBank: cc.EditBox = null

    @property(cc.Label)
    lbBankName: cc.Label = null

    @property(cc.EditBox)
    ebBankNo: cc.EditBox = null

    @property(cc.EditBox)
    ebBankAddres: cc.EditBox = null

    @property(cc.EditBox)
    ebRealName: cc.EditBox = null

    @property(cc.EditBox)
    ebAccount: cc.EditBox = null
    
    @property(cc.Label)
    lbAccountName: cc.Label = null
    
    @property(cc.Label)
    lbTipsBank: cc.Label = null
    
    @property(cc.Label)
    lbTipsOther: cc.Label = null
    
    @property(cc.Label)
    lbTipsUsdt: cc.Label = null

    @property(cc.Node)
    usdtBankListNode: cc.Node = null

    @property(cc.Layout)
    lytUsdtBankList: cc.Layout = null
    
    @property(cc.Node)
    nodeTemplateUsdtBank: cc.Node = null

    @property(cc.Label)
    lbUsdtBankName: cc.Label = null

    @property(cc.EditBox)
    ebUsdtBankAddres: cc.EditBox = null

    private _bankID: number = 0
    private _realUserName: string = ""
    private _usdtBankID: number = 0


    onLoad () {
        this.nodeInfoLayer.active = true
        this.nodeBankLayer.active = false
        this.nodeOtherLayer.active = false
        this.nodeUsdtLayer.active = false
        this.bankListNode.active = false
        this.usdtBankListNode.active = false
        this.nodeTemplateCard.parent = null
        this.nodeTemplateAddCard.parent = null
        this.nodeTemplateBank.parent = null
        this.nodeTemplateUsdtBank.parent = null
    }
    
    start () {
        this.pullPaymentData()        
        NetworkLogic.bankList(0, function (data) {
            this.createBankList(data)
        }.bind(this)) 
        NetworkLogic.bankList(3, function (data) {
            this.createUsdtBankList(data)
        }.bind(this))
    }

    onDisable () {
        this.nodeInfoLayer.active = true
        this.nodeBankLayer.active = false
        this.nodeOtherLayer.active = false
        this.nodeUsdtLayer.active = false
    }

    onDestroy () {
        this.nodeTemplateCard.destroy()
        this.nodeTemplateAddCard.destroy()
        this.nodeTemplateBank.destroy()
        this.nodeTemplateUsdtBank.destroy()
    }

    onBtnClick (event, userData) {
        if (userData === "addBank") {
            this.nodeInfoLayer.active = false
            let type = parseInt(this.toggleContainer.checkedToggle.userData["value"])

            // 银行卡
            if (type === 0) {
                this.nodeBankLayer.active = true
                this.lbTipsBank.string = this.toggleContainer.checkedToggle.userData["remark"]
            }else if (type === 3) {
                this.nodeUsdtLayer.active = true
                this.lbTipsUsdt.string = this.toggleContainer.checkedToggle.userData["remark"]
            }else {
                this.nodeOtherLayer.active = true
                let name = this.toggleContainer.checkedToggle.userData["label"]
                this.ebRealName.placeholder = "请输入" + name + "真实姓名"
                this.lbTipsOther.string = this.toggleContainer.checkedToggle.userData["remark"]
                this.ebAccount.inputMode = cc.EditBox.InputMode.SINGLE_LINE
                this.ebAccount.maxLength = 20

                if (type === 1) {
                    this.ebAccount.placeholder = "请输入" + name + "账号"
                    this.lbAccountName.string = name + "账号："
                }else if (type === 2) {
                    this.ebAccount.placeholder = "请输入手机号"
                    this.ebAccount.inputMode = cc.EditBox.InputMode.NUMERIC
                    this.ebAccount.maxLength = 11
                    this.lbAccountName.string = name + "手机号："
                }
            }
        }else if (userData === "pre") {
            this.nodeInfoLayer.active = true
            this.nodeBankLayer.active = false
            this.nodeOtherLayer.active = false
            this.nodeUsdtLayer.active = false
            this.clearData()
        }else if (userData === "confirm") {
            let type = parseInt(this.toggleContainer.checkedToggle.userData["value"])
            let username = this._realUserName || ""
            let bankId
            let bankNo
            let openbankBranch

            // 银行卡
            if (type === 0) {
                username = this.ebUserNameBank.string
                bankId = this._bankID
                bankNo = this.ebBankNo.string
                openbankBranch = this.ebBankAddres.string
            }else if (type === 3) { // usdt
                bankId = this._usdtBankID
                bankNo = this.ebUsdtBankAddres.string
            }else { // 微信支付宝
                username = this.ebRealName.string
                bankNo = this.ebAccount.string
            }

            UIManager.showLoadingUI()
            NetworkLogic.bindBank({ 
                type: type,
                username: username,
                bankId: bankId,
                bankNo: bankNo,
                openbankBranch: openbankBranch
            }, function (data) {
                UIManager.hideLoadingUI()
                this.nodeInfoLayer.active = true
                this.nodeBankLayer.active = false
                this.nodeOtherLayer.active = false
                this.nodeUsdtLayer.active = false
                this.clearData()
                this.pullPaymentData()
            }.bind(this))
        }else if (userData === "bankList") {
            this.bankListNode.active = !this.bankListNode.active
        }else if (userData === "bankListUsdt") {
            this.usdtBankListNode.active = !this.usdtBankListNode.active
        }else if (userData === "bankItem") {
            this._bankID = event.target["bankCfg"]["id"]
            this.lbBankName.string = event.target["bankCfg"]["text"]
            this.bankListNode.active = false
        }else if (userData === "bankItemUsdt") {
            this._usdtBankID = event.target["bankCfg"]["id"]
            this.lbUsdtBankName.string = event.target["bankCfg"]["text"] + "-" + Type2LinkName[event.target["bankCfg"]["virtualMoneyLinkType"]] 
            this.usdtBankListNode.active = false
        }
    }

    onToggleSelected (toggle: ToggleItem) {
        let bankList = toggle.userData["bankList"] || []
        this.lytBankInfoList.node.destroyAllChildren()

        bankList.forEach(cfg => {
            this.addBankCard(cfg)
        });

        let nodeAddCard = cc.instantiate(this.nodeTemplateAddCard)
        this.lytBankInfoList.node.addChild(nodeAddCard)
        nodeAddCard.getChildByName("tips").getComponent(cc.Label).string = "添加" + toggle.userData["label"]
    }

    private clearData () {
        this.ebRealName.string = this._realUserName
        this.ebUserNameBank.string = this._realUserName
        this.ebBankAddres.string = ""
        this.ebBankNo.string = ""
        this.ebUsdtBankAddres.string = ""
        this.ebAccount.string = ""
        this.lbBankName.string = ""
        this.lbUsdtBankName.string = ""
        this._bankID = 0
        this._usdtBankID = 0
    }

    private pullPaymentData () {
        NetworkLogic.getAllPaymentByUser(function (data) {
            this.toggleContainer.clear()
            this.createToggles(data.accountList)
            this._realUserName = data.realUserName

            if (this._realUserName) {
                this.ebRealName.string = this._realUserName
                this.ebUserNameBank.string = this._realUserName
                this.ebRealName.enabled = false
                this.ebUserNameBank.enabled = false
            }
        }.bind(this))
    }

    private createToggles (accountList) {
        accountList.forEach(cfg => {
            this.toggleContainer.addDefaultToggle(cfg.label, cfg)
        });
    }

    private addBankCard(cfg) {
        let node = cc.instantiate(this.nodeTemplateCard)
        node.parent = this.lytBankInfoList.node
        node.getChildByName("name").getComponent(cc.Label).string = cfg.bankname
        node.getChildByName("account").getComponent(cc.Label).string = cfg.bankNum
        cfg.logoUrl && cc.loader.load({url: cfg.logoUrl, type: "png"}, function (err, texture) {
            if (!err && node && node.isValid) {
                node.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
            }
        }.bind(this))
    }

    private createBankList (bankList) {
        bankList.forEach(cfg => {
            let bankNode = cc.instantiate(this.nodeTemplateBank)
            bankNode.parent = this.lytBankList.node
            bankNode.getChildByName("name").getComponent(cc.Label).string = cfg.text
            bankNode["bankCfg"] = cfg
        });
    }

    private createUsdtBankList (bankList) {
        bankList.forEach(cfg => {
            let bankNode = cc.instantiate(this.nodeTemplateUsdtBank)
            bankNode.parent = this.lytUsdtBankList.node
            bankNode.getChildByName("name").getComponent(cc.Label).string = cfg.text + "-" + Type2LinkName[cfg.virtualMoneyLinkType]
            bankNode["bankCfg"] = cfg
        });
    }
}
